import { useMemo } from "react";
import { CHART_COLORS } from "@/components/analytics/ChartCanvas";
import type { KpiRow } from "@/lib/reporting.api";

export function useKpiComparisonChartConfig(rows: KpiRow[], color: string) {
  return useMemo(
    () => ({
      type: "bar" as const,
      data: {
        labels: rows.map((row) => row.name),
        datasets: [
          {
            label: "Valeur (XAF)",
            data: rows.map((row) => row.value),
            backgroundColor: color,
            borderRadius: 4,
          },
        ],
      },
      options: {
        indexAxis: "y" as const,
        plugins: { legend: { display: false } },
        scales: {
          x: {
            ticks: { font: { size: 11 }, color: CHART_COLORS.muted },
            grid: { color: CHART_COLORS.grid },
            beginAtZero: true,
          },
          y: {
            ticks: { font: { size: 11 }, color: CHART_COLORS.muted },
            grid: { display: false },
          },
        },
      },
    }),
    [color, rows],
  );
}
